export const timeSpent = (startDateParam) => {
    const today = new Date()
    const startDate = new Date(startDateParam)
    let months = (today.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += today.getMonth();
    const timeSpent = months <= 0 ? 0 : months;
    
    return timeSpent
}